import React from "react";
import icon from "./icon.svg";

function OpenIcon({ className }: { className?: string }) {
  return <img src={icon} className={className} alt="" />;
}

export { OpenIcon };
